import { Notify } from "@/components/ui/notify";

export async function cancelWithConfirm(
  isDirty: boolean,
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>,
  onCancel?: () => void
): Promise<void> {
  if (isDirty) {
    const ok = await Notify.confirm({
      variant: "warning",
      title: "Descartar alterações não salvas?",
      confirmLabel: "Descartar",
    });
    if (!ok) return;
  }
  setIsDirty(false);
  onCancel?.();
}
